export type ShipmentStatus = 'pending' | 'hold' | 'on_hold' | 'picked_up' | 'in_transit' | 'out_for_delivery' | 'delivered';

export interface TimelineEvent {
  status: ShipmentStatus;
  timestamp: string;
  location: string;
  description: string;
}

export interface Shipment {
  id: string;
  sender: { name: string; address: string; city: string; country: string };
  receiver: { name: string; address: string; city: string; country: string; email?: string };
  status: ShipmentStatus;
  weight: number;
  dimensions: string;
  service: string;
  carrier: string;
  estimatedDelivery: string;
  origin: { lat: number; lng: number; city: string; country: string };
  destination: { lat: number; lng: number; city: string; country: string };
  currentLocation?: { lat: number; lng: number; city: string };
  timeline: TimelineEvent[];
  description: string;
  value: number;
  paymentMethod?: string;
  note?: string;
  reason?: string;
}

export const STATUS_CONFIG: Record<ShipmentStatus, { label: string; color: string; bg: string; icon: string; blinkClass: string }> = {
  pending:         { label: 'Pending',          color: 'text-amber-500', bg: 'bg-amber-500/10 border-amber-500/20',  icon: 'ri-time-line',           blinkClass: ''                   },
  hold:            { label: 'On Hold',          color: 'text-red-500',   bg: 'bg-red-500/10 border-red-500/20',     icon: 'ri-pause-circle-line',   blinkClass: 'badge-blink-red'    },
  on_hold:         { label: 'On Hold',          color: 'text-red-500',   bg: 'bg-red-500/10 border-red-500/20',     icon: 'ri-pause-circle-line',   blinkClass: 'badge-blink-red'    },
  picked_up:       { label: 'Picked Up',        color: 'text-amber-500', bg: 'bg-amber-500/10 border-amber-500/20', icon: 'ri-box-3-line',          blinkClass: 'badge-blink-yellow' },
  in_transit:      { label: 'In Transit',       color: 'text-teal-500',  bg: 'bg-teal-500/10 border-teal-500/20',   icon: 'ri-truck-line',          blinkClass: ''                   },
  out_for_delivery:{ label: 'Out for Delivery', color: 'text-green-500', bg: 'bg-green-500/10 border-green-500/20', icon: 'ri-e-bike-2-line',       blinkClass: 'badge-blink-green'  },
  delivered:       { label: 'Delivered',        color: 'text-green-600', bg: 'bg-green-600/10 border-green-600/20', icon: 'ri-checkbox-circle-line',blinkClass: ''                   },
};